<p>form-open-stat works!</p>
